import React from 'react';
import { Home, DollarSign, Shield, Settings } from 'lucide-react';
import { useNavigate } from 'react-router-dom';

const PlayerMobileBottomNav = ({ view, setView, playerData }) => {
    const navigate = useNavigate();
    // Check if user is captain or vice-captain of any team
    let isCaptainOrVC = false;
    if (playerData?.allTeams) {
        isCaptainOrVC = playerData.allTeams.some(t => t.teamRole === 'captain' || t.teamRole === 'vice-captain');
    } else if (playerData?.teamRole === 'captain' || playerData?.teamRole === 'vice-captain') {
        isCaptainOrVC = true;
    }

    const scrollToSection = (sectionId) => {
        if (view !== 'dashboard') {
            setView('dashboard');
            // Give it a tiny bit of time to render the dashboard view before scrolling
            setTimeout(() => {
                const element = document.getElementById(sectionId);
                if (element) {
                    element.scrollIntoView({ behavior: 'smooth', block: 'start' });
                }
            }, 100);
        } else {
            const element = document.getElementById(sectionId);
            if (element) {
                element.scrollIntoView({ behavior: 'smooth', block: 'start' });
            } else {
                window.scrollTo({ top: 0, behavior: 'smooth' });
            }
        }
    };

    // Main bottom tabs
    const navItems = [
        { id: 'dashboard', label: 'Home', icon: Home, action: () => setView('dashboard') },
        { id: 'mobile-dues', label: 'Dues', icon: DollarSign, action: () => setView('mobile-dues') },
    ];

    if (isCaptainOrVC) {
        navItems.push({ id: 'captains-corner', label: 'Captain', icon: Shield, action: () => setView('captains-corner') });
    }

    if (playerData?.role === 'admin') {
        navItems.push({ id: 'admin', label: 'Admin', icon: Settings, action: () => navigate('/admin') });
    }

    return (
        <div className="fixed bottom-0 left-0 right-0 bg-white border-t border-gray-100 z-50 md:hidden pb-safe">
            <div className="flex justify-around items-center h-[5.5rem] pb-4">
                {navItems.map((item) => {
                    const Icon = item.icon;
                    const isTrueActive = view === item.id;

                    return (
                        <button
                            key={item.id}
                            onClick={item.action}
                            className={`flex flex-col items-center justify-center w-full h-full space-y-1 transition-colors ${isTrueActive ? 'text-slate-900' : 'text-gray-400 hover:text-gray-600'
                                }`}
                        >
                            <Icon size={24} className={isTrueActive ? 'text-slate-900' : 'text-gray-400'} strokeWidth={isTrueActive ? 2.5 : 2} />
                            <span className={`text-[11px] font-bold ${isTrueActive ? 'text-slate-900' : 'text-gray-400'}`}>{item.label}</span>
                        </button>
                    );
                })}
            </div>
        </div>
    );
};

export default PlayerMobileBottomNav;
